"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AdAdminsAddedAutomaticallyGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 17",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.02 1.354c.013-.208.024-.854.042-1.134.217.207 1.514 1.496 1.792 1.684-.272-.184.123.084 0 0-.11.028-1.727 1.58-1.768 1.612-.032-.264-.054-.843-.076-1.024-1.887-.257-4.165 1.161-5.21 3.295-.918 1.873-.961 4.873 1.805 7.199l-.526.733C2.037 12.565.86 9.59 1.359 6.89c.566-3.07 2.846-4.975 6.66-5.535z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M8.074 3.391c-.013-.138-.023-.312-.033-.474a9.527 9.527 0 00-.031-.425C6.123 2.235 3.845 3.653 2.8 5.787c-.918 1.873-.961 4.873 1.806 7.199l-.527.733C2.037 12.565.861 9.59 1.359 6.89c.566-3.07 2.846-4.976 6.66-5.535.006-.096.012-.283.018-.485.006-.179.011-.369.018-.517L8.062.22a13.973 13.973 0 01.243.237C8.687.83 9.372 1.5 9.709 1.789a3.535 3.535 0 00.145.115.175.175 0 00-.043.027l-.044.034c-.275.222-1.08.983-1.467 1.35a137.63 137.63 0 01-.214.2 3.777 3.777 0 01-.012-.124zm1.804-1.393v.003a.061.061 0 00.013-.004 7.278 7.278 0 00-.287.24c-.167.15-.38.347-.591.544-.212.198-.421.395-.58.546l-.195.184-.089.083-.14.112-.022-.178c-.016-.136-.03-.35-.043-.55l-.003-.053a17.698 17.698 0 00-.023-.343c-.894-.1-1.88.182-2.776.746A6.247 6.247 0 002.89 5.83l-.09-.044.09.044c-.9 1.837-.946 4.786 1.78 7.078l.072.06-.054.075-.527.733-.052.074-.078-.045C1.942 12.626.757 9.602 1.26 6.871m8.618-4.873c.045-.026.09-.09.065-.153l-.006-.005-.002-.001-.001-.001-.024-.016a4.273 4.273 0 01-.355-.305c-.163-.15-.358-.334-.55-.52-.23-.221-.46-.446-.63-.612L8.13.148 7.976 0l-.014.214c-.009.142-.016.375-.023.597l-.002.054c-.004.155-.009.3-.013.402-1.883.287-3.398.905-4.517 1.836-1.136.946-1.86 2.212-2.146 3.768",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M7.98 15.087c-.013.208-.024.853-.042 1.133-.217-.207-1.514-1.495-1.792-1.684-.123-.083.272.184 0 0 .11-.027 1.727-1.579 1.767-1.611.033.264.055.842.077 1.023 1.887.258 4.165-1.161 5.21-3.295.918-1.872.961-4.872-1.806-7.198l.527-.734c2.042 1.155 3.218 4.131 2.72 6.83-.567 3.07-2.846 4.976-6.66 5.536z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M14.64 9.55c-.566 3.071-2.845 4.977-6.66 5.537-.006.095-.011.282-.017.484a38.19 38.19 0 01-.025.65 12.158 12.158 0 01-.243-.237c-.382-.374-1.067-1.044-1.404-1.332a3.46 3.46 0 00-.145-.116.176.176 0 00.043-.027l.044-.034c.275-.222 1.08-.983 1.467-1.35a172.486 172.486 0 01.213-.2c.005.036.01.078.013.124.012.138.023.313.033.474.011.18.021.343.031.425 1.887.258 4.165-1.161 5.21-3.295.918-1.873.961-4.872-1.806-7.198l.527-.734c2.042 1.155 3.218 4.131 2.72 6.83zM8.083 13.86c-.007-.087-.015-.21-.023-.343l-.004-.055a10.85 10.85 0 00-.042-.549l-.022-.178-.14.113a3.19 3.19 0 00-.09.082l-.194.185c-.16.15-.368.348-.58.545-.211.198-.424.394-.591.544a7.296 7.296 0 01-.271.23.268.268 0 01-.016.01l-.002.001.014-.005.001.003c-.045.026-.09.09-.065.154l.005.004.002.001.001.001h.001l.024.017c.062.042.19.152.355.304.163.15.358.335.55.52.23.222.46.446.63.613.114.11.2.195.244.236l.155.148.014-.213c.009-.143.016-.376.023-.598l.002-.054c.004-.155.009-.3.013-.402 1.883-.287 3.397-.904 4.517-1.836 1.136-.946 1.859-2.211 2.146-3.768.504-2.73-.682-5.755-2.769-6.935l-.078-.044-.052.073-.527.733-.054.076.071.06c2.727 2.292 2.68 5.24 1.78 7.077a6.248 6.248 0 01-2.253 2.504c-.895.563-1.881.845-2.775.746z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.836,
    height: 2.568,
    x: 4.582,
    y: 5.285,
    fill: "#6C757D",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.836,
    height: 2.568,
    x: 4.582,
    y: 8.396,
    fill: "#6C757D",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.337,
    cy: 6.568,
    r: 0.528,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.337,
    cy: 9.68,
    r: 0.528,
    fill: "#fff"
  }));
}

AdAdminsAddedAutomaticallyGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AdAdminsAddedAutomaticallyGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AdAdminsAddedAutomaticallyGreyOutline;
exports["default"] = _default;